import { StyleState, /* FilterState */ } from '../types/api';

const DEFAULT_STYLE: StyleState = {
  type: 'photorealistic',
  ratio: 'vertical',
  scene: 'mid-closeup'
};

/**
 * Calculate the number of style properties that differ from default
 * @param style Current style state
 * @returns Number of changed properties (0-3)
 */
export function calculateStyleCount(style: StyleState): number {
  let count = 0;
  if (style.type !== DEFAULT_STYLE.type) count++;
  if (style.ratio !== DEFAULT_STYLE.ratio) count++;
  if (style.scene !== DEFAULT_STYLE.scene) count++;
  return count;
}

/**
 * Format hair array for display
 * @param hairArray Array of hair values
 * @returns Display string (e.g., "Hair 2/7")
 */
export function formatHairDisplay(hairArray: string[]): string {
  const selectedCount = hairArray.length;
  const totalOptions = 7; // blonde, brunette, black, curly, straight, grey, pink (excluding "any")
  return `Hair ${selectedCount}/${totalOptions}`;
}

/**
 * Format style for display
 * @param style Current style state
 * @returns Display string (e.g., "Style 1/3")
 */
export function formatStyleDisplay(style: StyleState): string {
  const count = calculateStyleCount(style);
  return `Style ${count}/3`;
}

/**
 * Check if a filter value is non-default (not "any" or empty)
 * @param value Filter value (string or string[])
 * @returns True if value is selected (not default)
 */
export function isFilterSelected(value: string | string[]): boolean {
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  return value !== 'any';
}

/**
 * Convert hair array to comma-separated string for backend
 * @param hairArray Array of hair values
 * @returns Comma-separated string (e.g., "blonde,curly")
 */
export function hairArrayToString(hairArray: string[]): string {
  return hairArray.join(',');
}

/**
 * Convert comma-separated string to hair array
 * @param hairString Comma-separated string (e.g., "blonde,curly")
 * @returns Array of hair values
 */
export function stringToHairArray(hairString: string | string[]): string[] {
  if (Array.isArray(hairString)) {
    return hairString;
  }
  if (hairString === 'any' || !hairString) {
    return [];
  }
  return hairString.split(',').filter(Boolean);
}

